export { EmployeeINNField } from './EmployeeINNField';
export { checkMatchInn, validateEmployeeINN } from './EmployeeINNField.validation';
